/**
*****************************************
*										                    *
* NAGARRO  - CSX - CONFIDENTIAL         *
*										                    *
*****************************************
*/
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api/selectitem';
import { SplitButton } from 'primeng/splitbutton';
import { MenuItem } from 'primeng/api/menuitem';

import { AppUtilityService } from '../../../core/services/app-utility.service';
import { BaseResponse } from '../../../core/model/base-response.model';
import { BreTransferAreaDetails } from '../../../core/model/bre-transfer-area-details.model';
import { ConfigService } from './../../../core/services/config.service';
import { EditModeService } from '../../../core/services/edit-mode.service';
import { LmsException } from '../../../core/model/lms-exception.model';
import { LmsLoaderService } from '../../../core/services/lms-loader.service';
import { LocoDetail } from './../../../core/model/loco-detail.model';
import { LocoTransfer } from '../../../core/model/loco-transfer.model';
import { MessageDetails } from '../../../core/model/message-details.model';
import { MessageHandlerService } from '../../../core/services/message-handler.service';
import { PopupService } from '../../../core/services/popup.service';
import { StaticDataStoreService } from '../../../core/services/static-datastore.service';
import { Tab } from './../../../core/model/tab.model';
import { TerminalRoad } from '../../../core/model/terminal-road-model';
import { TrainData } from './../../../core/model/train-data.model';
import { TrainDataService } from '../../services/train-data.service';
import { TrainEditOps } from '../../shared/model/train-edit-operation.model';
import { UserService } from '../../../core/services/user.service';

/**
 * This LmsTrainTopActions Component is created
 * for displaying actions related to train data information.
 * @export
 * @class LmsTrainTopActionsComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-train-top-actions',
  templateUrl: './lms-train-top-actions.component.html',
  styleUrls: ['./lms-train-top-actions.component.scss']
})
export class LmsTrainTopActionsComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {

  @ViewChild('trainSplitBtn') trainSplitBtnRef: any;
  @Input() subTypes: Array<string>;
  @Input() tab: Tab;
  @Input() trainSVG: TrainData;
  @Input() trainEdit: TrainEditOps;
  @Input() bottomToTop: string;
  @Input() hideSplitBtn: string;
  @Input() popHideAction: any;
  @Input() disableCancelComplete: boolean;

  @Output() disableCancelCompleteEmit: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() editAction: EventEmitter<TrainEditOps> = new EventEmitter<TrainEditOps>();

  @Output() actionTrigger: EventEmitter<string> = new EventEmitter<string>();

  @Output() addTrain: EventEmitter<string> = new EventEmitter<string>();

  @Output() cancelCompleteTrain: EventEmitter<string> = new EventEmitter<string>();

  @Output() setTrainPosition: EventEmitter<string> = new EventEmitter<string>();

  @Output() cancelLocoPlan: EventEmitter<LocoDetail[]> = new EventEmitter<LocoDetail[]>();

  @Output() setNormal: EventEmitter<string> = new EventEmitter<string>();

  @Output() hideContextMenu: EventEmitter<boolean> = new EventEmitter<boolean>();

  tabLevel: number;
  tabLevelDialog: number;
  splitButton: SplitButton;
  transferResponse: BaseResponse;
  configData: any;

  otherOptions: MenuItem[];
  planOptions: SelectItem[];
  locoPlannedTo: string;
  selectedOption: string;
  trainNaIcon: string;
  newTrainID: string;
  confirmAction: string;
  confirmMessage: string;
  planTerminalID: string;
  searchPlanTextTerminal: string;
  filteredResults: string[] = [];
  mileposts: string[] = [];
  mnemonics: string[] = [];
  roadValues: Array<TerminalRoad>;
  selectedTerminalRoad: string;
  selectedRoadValues: SelectItem[];
  planTrainId: string;
  thpPlanLoco: string;
  searchTextTerminal: string;
  searchUpdateTextTerminal: string;
  addLocoCurrentTerminal = '';
  popUpHeaderMessage: string;
  addTrainHeader: string;
  confirmHeaderError: string;


  addTrainPop: boolean;
  confirmPop: boolean;
  planLocomotive: boolean;
  isAddTrainError: boolean;
  searchPlanTextTerminalError = false;
  selectedTerminalRoadError = false;
  planTrainIdError = false;
  editDisable: boolean;
  prevAction: string;
  errorDialog = false;
  ruleException = false;
  lmsExceptionList: Array<LmsException> = [];
  locoTransfer: Array<LocoTransfer> = [];
  isRuleExceptionSubmitEnabled: boolean;
  loco: LocoDetail;
  popUpServiceSubscription: any;
  isValidThpSelection = false;
  intendedTrainEdit: TrainEditOps;

  /**
   * Creates an instance of LmsTrainTopActionsComponent and inject the ConfigService.
   * @param {ConfigService} configService
   * @memberOf LmsTrainTopActionsComponent
   */
  constructor(private configService: ConfigService,
    private lmsLoaderService: LmsLoaderService,
    private staticDataStoreService: StaticDataStoreService,
    private trainDataService: TrainDataService,
    private editModeService: EditModeService,
    private messageHandlerService: MessageHandlerService,
    private popupService: PopupService,
    private appUtilityService: AppUtilityService, 
    public user: UserService) {
    this.configData = this.configService.getConfigData();
    this.trainNaIcon = this.configData.images.topAction.train.trainNaIcon;
    this.tabLevel = this.configData.tabIndex.subTabs;
    this.tabLevelDialog = this.configData.tabIndex.dialogBox;
    const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    this.otherOptions = [];
    this.isAddTrainError = false;
    this.editDisable = false;
    this.prepareOtherOptionsMenu();
    this.planOptions = [];
    this.roadValues = [];
    this.selectedRoadValues = [];
    this.planOptions.push({
      label: 'Train',
      value: 'train',
    });
    this.planOptions.push({
      label: 'Terminal',
      value: 'terminal'
    });
    this.planOptions.push({
      label: 'Foreign Railroad',
      value: 'foreignRailRoad'
    });
    this.locoPlannedTo = 'train';
    this.newTrainID = '';
    if (commonopsPicklist && commonopsPicklist.masterData && commonopsPicklist.masterData.interchangeList &&
      commonopsPicklist.masterData.interchangeList.length > 0) {
      for (let i = 0; i < commonopsPicklist.masterData.interchangeList.length; i++) {
        const terminalRoad: TerminalRoad = commonopsPicklist.masterData.interchangeList[i];
        this.roadValues.push(terminalRoad);
      }
    }
    this.popUpServiceSubscription = this.popupService.popupOprObservable.subscribe((data) => {
      this.checkSuccessOperation(data);
    });
  }

  checkSuccessOperation(opr: any) {
    if (opr && opr.operation === 'updateIntendedSuccess' && this.tab && this.tab.subTypeDetail) {
      this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status = 'refresh';
      this.trainDataService.load(this.tab, true, opr.message);
    }
  }

  /**
   * @memberOf LmsTrainTopActionsComponent
   */
  ngOnInit() {
    this.splitButton = this.trainSplitBtnRef;
  }

  ngAfterViewInit() {
    if (!this.trainEdit.otherActionDisable) {
      const splitComp = document.getElementById('trainDataSplitBtn');
      if (splitComp && splitComp.children[0] && splitComp.children[0].children[1]) {
        const dropDownBtn = splitComp.children[0].children[1];
        const mouseDownEvent = this.checkForContextMenuVisiblity.bind(this);
        dropDownBtn.addEventListener('mousedown', mouseDownEvent);
      }
    }
  }

  /**
   * @memberOf LmsTrainTopActionsComponent
   */
  ngOnChanges() {
    if (this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status === 'blank' || this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status === 'error') {
      this.editDisable = true;
      this.setDefaultValues();
      this.checkEditModeStatus();
    } else {
      this.editDisable = false;
    }
    this.prepareOtherOptionsMenu();
    if (this.popHideAction) {
      if ('AddTrain' === this.popHideAction.action) {
        this.addTrainPop = false;
        this.addTrainHeader = '';
        this.newTrainID = null;
        setTimeout(() => {
          this.actionTrigger.emit('cancel');
        }, 5);
      } else if ('CnfrmActn' === this.popHideAction.action) {
        this.confirmPop = false;
        this.confirmAction = '';
        this.confirmMessage = '';
        this.confirmHeaderError = '';
        setTimeout(() => {
          this.actionTrigger.emit('cancel');
        }, 5);
      } else if (this.popHideAction.action === 'rSeqComplete') {
        setTimeout(() => {
          this.cancelActionTrigger(null);
        }, 5);
      } else if (this.popHideAction.action === 'ErrorTrain') {
        this.addTrainHeader = this.popHideAction.message;
      } else if (this.popHideAction.action === 'ErrorCnfrmActn') {
        this.confirmHeaderError = this.popHideAction.message;
      }
    }
    this.popHideAction = {};
    this.checkEditModeStatus();

    if (this.trainEdit && (this.trainEdit.locoEditMode || this.trainEdit.dragMode)) {
      this.popupService.setPageMode('Edit');
      this.popupService.setSubmitBtnId('trainDataSubmitBtn');
    }

    this.checkSplitButtonFocus();
    if (this.trainSVG) {
      this.trainEdit.editDisable = (this.trainSVG.locoDetails && this.trainSVG.locoDetails.length > 0) ? false : true;
    }

    if (this.hideSplitBtn && this.hideSplitBtn === 'hide') {
      if (this.splitButton) {
        // this.splitButton.menuVisible = false; // @@7749 [Commented out] menuVisible is invalid property on SplitButton. Need to check the functionality
      }
    }

  }

  /**
   * this mehtod is used to check for focus of active element
   * when user uses tab to operate application.
   * this method sets the focus to button of split btn
   * @private
   * @memberOf LmsTrainTopActionsComponent
   */
  private checkSplitButtonFocus() {
    const splitBtn = document.getElementById('trainDataSplitBtn');
    if (splitBtn) {
      setTimeout(() => {
        let tabIndexTemp = splitBtn.getAttribute('tabIndex');
        if (!tabIndexTemp) {
          tabIndexTemp = '2017';
        }
        const tabIndex = parseInt(tabIndexTemp, 10);
        if (tabIndex && tabIndex > 0) {
          splitBtn.children[0].children[1].setAttribute('tabIndex', tabIndex.toString());
          splitBtn.removeAttribute('tabIndex');
          if (splitBtn.children[0]?.children[2]?.children[0]?.children) {
            const menuOptions = splitBtn.children[0].children[2].children[0].children;
            for (let i = 0; i < menuOptions.length; i++) {
              menuOptions[i].setAttribute('tabIndex', (tabIndex + i + 1).toString());
            }
          }
          
        }
      }, 10);
    }
  }

  /**
   * this method is used to check
   * current edit mode status of screen user currently
   * on
   * @private
   * @memberOf LmsTrainTopActionsComponent
   */
  private checkEditModeStatus() {
    if (this.trainEdit && (this.trainEdit.dragMode || this.trainEdit.locoEditMode)) {
      const editModeStatus = {
        status: true,
        message: 'Unsaved data will be lost. Do you want to continue?'
      };
      this.editModeService.setEditMode(editModeStatus);
    } else {
      const editModeStatus = {
        status: false,
        message: ''
      };
      this.editModeService.setEditMode(editModeStatus);
    }
  }

  /**
   * This method is used to control the
   * locomotive selection
   * @private
   * @param {boolean} isRemove
   * @memberOf LmsTrainTopActionsComponent
   */
  private controlLocomotiveSelection(isRemove: boolean) {
    if (!isRemove && this.trainEdit.selectedLocomotives && this.trainEdit.selectedLocomotives.length > 0) {
      this.trainEdit.selectedLocomotives.forEach(element => {
        const elem = document.getElementById('selection' + element.locomotiveIdentifier);
        if (elem) {
          elem.setAttribute('class', 'locomotiveSelection');
        }
      });
    } else if (isRemove && this.trainEdit.selectedLocomotives && this.trainEdit.selectedLocomotives.length > 0) {
      this.trainEdit.selectedLocomotives.forEach(element => {
        const elem = document.getElementById('selection' + element.locomotiveIdentifier);
        if (elem) {
          elem.removeAttribute('class');
        }
      });
      this.trainEdit.selectedLocomotives = [];
    }
  }

  /**
   * This method is used to prepare the otherAction menu items
   * we prepare the enable/disable of these items
   * @private
   * @memberOf LmsTrainTopActionsComponent
   */
  private prepareOtherOptionsMenu() {
    this.otherOptions = [
      {
        label: 'Add Train', command: () => {
          this.otherActionTaken('AddTrain');
        }, disabled: false
      },
      {
        label: 'Complete Train', command: () => {
          this.otherActionTaken('CompleteTrain');
        }, disabled: this.tab && this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status === 'loaded' ? false : true
      },
      {
        label: 'Cancel Train', command: () => {
          this.otherActionTaken('CancelTrain');
        }, disabled: this.tab && this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status === 'loaded' ? false : true
      },
      {
        label: 'Set Train Position', command: () => {
          this.otherActionTaken('SetTrainPosition');
        }, disabled: this.tab && this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status === 'loaded' ? false : true
      },
      {
        label: 'Plan Locomotive', command: () => {
          this.otherActionTaken('PlanLocomotive');
        }, disabled: (this.tab && this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status === 'loaded'
          && this.trainEdit.selectedLocomotives && this.trainEdit.selectedLocomotives.length > 0) ? false : true
      },
      {
        label: 'Update Locomotive', command: () => {
          this.otherActionTaken('UpdateLocomotive');
        }, disabled: (this.tab && this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status === 'loaded'
          && this.trainEdit.selectedLocomotives && this.trainEdit.selectedLocomotives.length > 0) ? false : true
      },
      {
        label: 'Cancel Locomotive Plan', command: () => {
          this.otherActionTaken('CancelLocomotivePlan');
        }, disabled: (this.tab && this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status === 'loaded'
          && this.enableCancelLocomotivePlan()) ? false : true
      }
    ];
  }

  enableCancelLocomotivePlan() {
    let returnValue = false;
    let counter = 0;
    if (this.trainEdit.selectedLocomotives && this.trainEdit.selectedLocomotives.length > 0) {
      this.trainEdit.selectedLocomotives.forEach((locomotive) => {
        if (locomotive && locomotive.locomotiveIdentifier && locomotive.locomotiveIdentifier.toUpperCase() !== 'ZZZZZZZZZZZZZZ' && locomotive.assignedPlannedFlag && locomotive.assignedPlannedFlag.trim().toUpperCase() === 'P'
          && ((locomotive.plannedAssignment && locomotive.plannedAssignment.trim().length > 0) || (locomotive.plannedOrCurrentAssign && locomotive.plannedOrCurrentAssign.length > 0))) {
          counter++;
        }
      });
      if (counter > 0) {
        returnValue = true;
      }
    }
    return returnValue;
  }
  /**
   * This method is used to handle action taken from
   * otherAction buttons
   * @param {string} action
   * @memberOf LmsTrainTopActionsComponent
   */
  public otherActionTaken(action: string) {
    if (('AddTrain').toUpperCase() === action.toUpperCase()) {
      this.addTrainPop = true;
      this.addTrainHeader = 'Add Train';
      this.newTrainID = '';
      this.isAddTrainError = false;
      this.popupService.setPageMode('Dialog');
      this.popupService.setSubmitBtnId('addTrainSubmitBtn');
    } else if (('CompleteTrain').toUpperCase() === action.toUpperCase()) {
      this.confirmPop = true;
      this.confirmHeaderError = null;
      this.confirmAction = 'Complete Train';
      this.confirmMessage = `Are you sure you want to complete this Train?`;
      this.popupService.setPageMode('Dialog');
      this.popupService.setSubmitBtnId('confirmTrainBtn');
    } else if (('CancelTrain').toUpperCase() === action.toUpperCase()) {
      this.confirmPop = true;
      this.confirmHeaderError = null;
      this.confirmAction = 'Cancel Train';
      this.confirmMessage = `Are you sure you want to cancel this Train?`;
      this.popupService.setPageMode('Dialog');
      this.popupService.setSubmitBtnId('confirmTrainBtn');
    } else if (('SetTrainPosition').toUpperCase() === action.toUpperCase()) {
      this.lmsLoaderService.showLoader();
      this.setTrainPosition.emit('setTrainPosition');
    } else if (('PlanLocomotive').toUpperCase() === action.toUpperCase()) {

      this.getLocoIncident();
      this.isAddTrainError = false;
      this.errorDialog = false;
      this.popUpHeaderMessage = 'Plan Locomotive';
      this.locoPlannedTo = 'train';
      this.thpPlanLoco = 'S';
      this.changePlanOptions('Plan Locomotive');
      this.popupService.setPageMode('Dialog');
      this.popupService.setSubmitBtnId('trainPlanLocoSubBtn');
    } else if (('UpdateLocomotive').toUpperCase() === action.toUpperCase()) {
      this.trainEdit.locoEditMode = true;
      this.trainEdit.locoSelection = false;
      this.trainEdit.submitAction = false;
      this.trainEdit.dragMode = false;
      this.trainEdit.cancelDisable = false;
      this.trainEdit.editDisable = true;
      this.trainEdit.submitDisable = false;
      this.trainEdit.otherActionDisable = true;
      this.editAction.emit(this.trainEdit);
      this.actionTrigger.emit('updateLocomotive');
    } else if (('CancelLocomotivePlan').toUpperCase() === action.toUpperCase()) {
      this.cancelLocoPlan.emit(this.getLocomotivesForCancelPlan());
    }
  }

  getLocomotivesForCancelPlan(): any {
    const locos = [];
    if (this.trainEdit.selectedLocomotives && this.trainEdit.selectedLocomotives.length > 0) {
      this.trainEdit.selectedLocomotives.forEach((locomotive) => {
        if (locomotive && locomotive.locomotiveIdentifier && locomotive.locomotiveIdentifier.toUpperCase() !== 'ZZZZZZZZZZZZZZ' && locomotive.assignedPlannedFlag && locomotive.assignedPlannedFlag.trim().toUpperCase() === 'P'
          && ((locomotive.plannedAssignment && locomotive.plannedAssignment.trim().length > 0) || (locomotive.plannedOrCurrentAssign && locomotive.plannedOrCurrentAssign.length > 0))) {
          locos.push(locomotive);
        }
      });
    }
    return locos;
  }

  /**
   * This method is used to handle the
   * edit button operation
   * @memberOf LmsTrainTopActionsComponent
   */
  public editActionTrigger(event) {
    document.getElementsByTagName('body')[0].click();
    if (event) {
      event.stopPropagation();
    }
    if (this.trainEdit) {
      this.lmsLoaderService.showLoader();
      this.trainEdit.draggable = false;
      this.trainEdit.locoEditMode = true;
      this.trainEdit.locoSelection = false;
      this.trainEdit.submitAction = false;
      this.trainEdit.dragMode = false;
      this.trainEdit.cancelDisable = false;
      this.trainEdit.editDisable = true;
      this.trainEdit.submitDisable = false;
      this.trainEdit.otherActionDisable = true;
      this.popupService.setPageMode('Edit');
      this.popupService.setSubmitBtnId('trainDataSubmitBtn');
      if (this.trainSVG.locoDetails && this.trainSVG.locoDetails.length > 0) {
        this.trainEdit.selectedLocomotives = this.trainSVG.locoDetails;
      }
      this.actionTrigger.emit('editAll');
      this.editAction.emit(this.trainEdit);
    }
  }



  /**
   * This method is used to handle the
   * cancel button operation
   * @memberOf LmsTrainTopActionsComponent
   */
  public cancelActionTrigger(event) {
    document.getElementsByTagName('body')[0].click();
    if (event) {
      event.stopPropagation();
    }
    this.setDefaultValues();
    this.prepareOtherOptionsMenu();
    this.editAction.emit(this.trainEdit);
    this.actionTrigger.emit('cancel');
    this.popupService.setPageMode('');
    this.popupService.setSubmitBtnId('');
    setTimeout(() => {
      const editBtn = document.getElementById('trainDataEditBtn');
      if (editBtn && (!(this.trainEdit.editDisable) && !this.editDisable && (this.user && this.user.isUserManagerOrDirector))) {
        editBtn.focus();
      }
    }, 50);
  }

  /**
   * This method is used to reset the default values
   * @private
   * @memberOf LmsTrainTopActionsComponent
   */
  private setDefaultValues() {
    if (this.user && this.user.isUserManagerOrDirector) {
      this.trainEdit.draggable = true;
    } else {
      this.trainEdit.draggable = false;
    }
    this.trainEdit.locoEditMode = false;
    this.trainEdit.locoSelection = true;
    this.trainEdit.submitAction = false;
    this.trainEdit.dragMode = false;
    this.trainEdit.cancelDisable = true;
    this.trainEdit.editDisable = (this.trainSVG && this.trainSVG.locoDetails && this.trainSVG.locoDetails.length > 0) ? false : true;
    this.trainEdit.submitDisable = true;
    this.trainEdit.otherActionDisable = false;
    this.controlLocomotiveSelection(true);
    this.lmsLoaderService.hideLoader();
  }

  /**
   * This method is used to handle submit action
   * @memberOf LmsTrainTopActionsComponent
   */
  public submitActionTrigger(event) {
    // document.getElementsByTagName('body')[0].click();
    if (event) {
      event.stopPropagation();
    }
    if (this.trainEdit.locoEditMode) {
      this.trainEdit.submitAction = true;
      this.editAction.emit(this.trainEdit);
      const submitBtn = document.getElementById('trainEditSubmitBtn');
      if (submitBtn) {
        submitBtn.click();
      }
    }
    if (this.trainEdit.dragMode) {
      this.lmsLoaderService.showLoader();
      this.prevAction = 'dragSubmit';
      this.actionTrigger.emit(this.prevAction);
    }
  }

  /**
   * This mehtod is used to handle
   * add train operation
   * @param {*} value
   * @memberOf LmsTrainTopActionsComponent
   */
  public addTrainData(value: any) {
    this.lmsLoaderService.showLoader();
    if (this.isValidTrainId(value.trainID)) {
      value.trainID = value.trainID.trim().toUpperCase();
      this.addTrain.emit(value.trainID);
      this.isAddTrainError = false;
    } else {
      this.isAddTrainError = true;
      this.lmsLoaderService.hideLoader();
    }
  }

  /**
   * This method is used to handle the
   * confirm popup yes operation
   * @param {string} action
   * @memberOf LmsTrainTopActionsComponent
   */
  public confirmbtnAction(action: string) {
    if ('Complete Train' === action) {
      this.lmsLoaderService.showLoader();
      this.cancelCompleteTrain.emit('completeTrain');
    } else if ('Cancel Train' === action) {
      this.lmsLoaderService.showLoader();
      this.cancelCompleteTrain.emit('cancelTrain');
    }
  }

  /**
   * this method is used to hide dialog opened
   * @param {string} action
   * @memberOf LmsTrainTopActionsComponent
   */
  public hideDialog(action: string) {
    if (action && action.length > 0) {
      if (('AddTrain').toUpperCase() === action.toUpperCase()) {
        this.addTrainPop = false;
        this.addTrainHeader = '';
        this.popupService.setPageMode('');
        this.popupService.setSubmitBtnId('');
      } else if (('Complete Train').toUpperCase() === action.toUpperCase()) {
        this.confirmPop = false;
        this.confirmHeaderError = null;
        this.confirmAction = null;
        this.confirmMessage = null;
        this.disableCancelCompleteEmit.emit(false);
        this.popupService.setPageMode('');
        this.popupService.setSubmitBtnId('');
      } else if (('Cancel Train').toUpperCase() === action.toUpperCase()) {
        this.confirmPop = false;
        this.confirmHeaderError = null;
        this.confirmAction = null;
        this.confirmMessage = null;
        this.disableCancelCompleteEmit.emit(false);
        this.popupService.setPageMode('');
        this.popupService.setSubmitBtnId('');
      } else if (('PlanLocomotive').toUpperCase() === action.toUpperCase()) {
        this.isAddTrainError = false;
        this.planLocomotive = false;
        this.popupService.setPageMode('');
        this.popupService.setSubmitBtnId('');
      } else if (('Cancel Locomotive Plan').toUpperCase() === action.toUpperCase()) {
        this.confirmPop = false;
        this.confirmAction = null;
        this.confirmMessage = null;
      } else if (('ruleException').toUpperCase() === action.toUpperCase()) {
        this.isAddTrainError = false;
        this.ruleException = false;
      }
    }
  }

  setPageMode(btnId: string) {
    if (btnId && btnId.length > 0) {
      this.popupService.setPageMode('Dialog');
      this.popupService.setSubmitBtnId(btnId);
    }
  }

  /**
   * This mehtod is used to reset values when user
   * changes values from the dropdown of plan locomotive
   * @memberOf LmsTrainTopActionsComponent
   */
  changePlanOptions(type?: string) {
    this.popUpHeaderMessage = type;
    this.errorDialog = false;
    this.searchPlanTextTerminal = '';
    this.searchPlanTextTerminalError = false;
    this.selectedTerminalRoad = '';
    this.selectedTerminalRoadError = false;
    this.isAddTrainError = false;
    this.isValidThpSelection = false;
    this.thpPlanLoco = 'S';
    this.planTrainId = '';
    this.selectedRoadValues = [];
    this.selectedRoadValues.push({
      label: '',
      value: ''
    });
    setTimeout(() => {
      if (this.locoPlannedTo && this.locoPlannedTo === 'foreignRailRoad') {
        this.setFocusToGivenElement('trainDataPlanLocoFrgnInp');
      } else if (this.locoPlannedTo && this.locoPlannedTo === 'train') {
        this.setFocusToGivenElement('trainDataPlanLocoTrainbox');
      } else if (this.locoPlannedTo && this.locoPlannedTo === 'terminal') {
        this.setFocusToGivenElement('trainDataPlanLocoFrgnInp');
      }
    }, 20);
  }

  /**
   * this method is used to reset
   * all operation of plan locomotive pop
   * @memberOf LmsTrainTopActionsComponent
   */
  public resetPlanLocomotiveToDefault() {
    this.loco = {};
    this.planLocomotive = false;
    this.isAddTrainError = false;
    this.locoPlannedTo = 'train';
    this.thpPlanLoco = 'S';
    this.searchPlanTextTerminal = '';
    this.searchPlanTextTerminalError = false;
    this.selectedTerminalRoad = '';
    this.selectedTerminalRoadError = false;
    this.changePlanOptions();
  }

  resetPageMode() {
    if (this.trainEdit.selectedLocomotives) {
      for (let i = 0; i < this.trainEdit.selectedLocomotives.length; i++) {
        if (this.trainEdit.selectedLocomotives[i]) {
          this.trainEdit.selectedLocomotives[i].intendedUsgaeNoteRequired = false;
        }
      }
    }
    this.loco = {};
    this.popupService.setPageMode('');
    this.popupService.setSubmitBtnId('');
  }
  /**
   * This mehtod is used to populate the
   * suggestion list for autoCompleteForTerminal
   * @param {any} event
   * @memberOf LmsTrainTopActionsComponent
   */
  autoCompleteForTerminal(event) {
    this.mnemonics = [];
    this.mileposts = [];
    const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    const data = commonopsPicklist.mapOfMnemonis ? commonopsPicklist.mapOfMnemonis : null;
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        this.mnemonics.push(data[key]);
        this.mileposts.push(key);
      }
    }
    this.filteredResults = this.mnemonics.filter((s) => {
      return s.startsWith(event.query.toUpperCase());
    });

    Array.prototype.push.apply(this.filteredResults, (this.mileposts.filter((s) => {
      return s.startsWith(event.query.toUpperCase());
    })));
    this.filteredResults = this.filteredResults.filter(function (item, index, inputArray) {
      return inputArray.indexOf(item) === index;
    });
    this.filteredResults.sort();
  }

  /**
   * This method is used to select
   * and assign values to select operation
   * @param {string} value
   * @param {string} type
   * @memberOf LmsTrainTopActionsComponent
   */
  selectValueFromAutoComplete(value: string, type: string, popupType?: string, ) {
    this.selectedTerminalRoadError = false;
    this.searchPlanTextTerminalError = false;
    this.selectedTerminalRoad = '';

    let emitValue = value;
    const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    if (commonopsPicklist) {
      const data = commonopsPicklist.mapOfMnemonis ? commonopsPicklist.mapOfMnemonis : null;
      if (data) {
        if (data[value]) {
          emitValue = data[value];
        }
      }
    }
    if (this.roadValues) {
      this.selectedRoadValues = [];
      const filteredRoadValues: Array<TerminalRoad> = this.roadValues.filter((terminalRoad) => {
        return terminalRoad.terminal === emitValue;
      });
      if (filteredRoadValues && filteredRoadValues.length > 0) {
        this.selectedRoadValues.push({
          label: 'Select',
          value: 'Select'
        });
      }
      for (const filteredRoadValue of filteredRoadValues) {
        this.selectedRoadValues.push({
          label: filteredRoadValue.road,
          value: filteredRoadValue.road
        });
        if (this.selectedRoadValues && this.selectedRoadValues.length > 0) {
          this.selectedTerminalRoad = this.selectedRoadValues[0].value;
        }
      }
      if (this.locoPlannedTo === 'foreignRailRoad') {
        if (!filteredRoadValues || (filteredRoadValues && filteredRoadValues.length <= 0)) {
          this.errorDialog = true;
          this.popUpHeaderMessage = this.configData.messages.planInvalidInterchangeRoad;
        } else {
          this.popUpHeaderMessage = 'Plan Locomotive';
          this.errorDialog = false;
        }
      }
    }
    if ('terminalUpdateSuggestSearch' === type) {
      this.searchUpdateTextTerminal = emitValue;
    } else if ('terminalSuggestSearch' === type) {
      this.searchTextTerminal = emitValue;
    } else if ('terminalPlanSuggestSearch' === type) {
      this.searchPlanTextTerminal = emitValue;
    } else if ('assignmentTypeTerminal' === type) {
      this.addLocoCurrentTerminal = emitValue;
    }
    if (this.planLocomotive && !this.appUtilityService.isValidThpSelection(this.searchPlanTextTerminal)) {
      this.thpPlanLoco = 'M';
      this.isValidThpSelection = true;
    } else {
      this.thpPlanLoco = 'S';
      this.isValidThpSelection = false;
    }
  }

  /**
   * This mehtod is used to handle the
   * plan locomotive submit operation
   * @memberOf LmsTrainTopActionsComponent
   */
  planLocomotiveSubmit() {
    if (this.searchPlanTextTerminal) {
      this.searchPlanTextTerminal = this.searchPlanTextTerminal.toUpperCase();
    }
    this.searchPlanTextTerminalError = false;
    this.selectedTerminalRoadError = false;
    if (this.locoPlannedTo === 'foreignRailRoad') {
      if (this.appUtilityService.isMnemonicExist(this.searchPlanTextTerminal) && (this.selectedTerminalRoad && 'Select' !== this.selectedTerminalRoad)) {
        this.lmsLoaderService.showLoader();
        this.submitTransferToForeignRailRoad();
      } else {
        if (!this.appUtilityService.isMnemonicExist(this.searchPlanTextTerminal)) {
          this.searchPlanTextTerminalError = true;
        } else {
          this.searchPlanTextTerminalError = false;
        }
        if (!this.selectedTerminalRoad || 'Select' === this.selectedTerminalRoad) {
          this.selectedTerminalRoadError = true;
        } else {
          this.selectedTerminalRoadError = false;
        }
      }
    } else if (this.locoPlannedTo === 'train') {
      if (this.isValidTrainId(this.planTrainId)) {
        this.lmsLoaderService.showLoader();
        this.planTrainId = this.planTrainId.toUpperCase();
        this.isAddTrainError = false;
        let isNoteError = false;
        if (this.intendedTrainEdit) {
          for (let p = 0; p < this.intendedTrainEdit.selectedLocomotives.length; p++) {
            if (this.intendedTrainEdit.selectedLocomotives[p] &&
              this.intendedTrainEdit.selectedLocomotives[p].intendedUsgaeNoteRequired &&
              (!this.intendedTrainEdit.selectedLocomotives[p].intendedUsageNote ||
                (this.intendedTrainEdit.selectedLocomotives[p].intendedUsageNote &&
                  this.intendedTrainEdit.selectedLocomotives[p].intendedUsageNote.length === 0))) {
              this.intendedTrainEdit.selectedLocomotives[p].isIntendedUsageNotError = true;
              isNoteError = true;
            } else {
              if (this.intendedTrainEdit.selectedLocomotives[p].intendedUsageNote) {
                this.intendedTrainEdit.selectedLocomotives[p].intendedUsageNote = this.intendedTrainEdit.selectedLocomotives[p].intendedUsageNote.trim().toUpperCase();
              }
              this.intendedTrainEdit.selectedLocomotives[p].isIntendedUsageNotError = false;
            }
          }
        }
        if (!isNoteError) {
          this.trainEdit = JSON.parse(JSON.stringify(this.intendedTrainEdit));
          let selectedLocoArr = [];
          if (this.trainEdit && this.trainEdit.selectedLocomotives) {
            selectedLocoArr = this.trainEdit.selectedLocomotives;
          }
          this.serviceCallToBre(this.planTrainId, selectedLocoArr, 'planLocomotive');
        } else {
          this.lmsLoaderService.hideLoader();
        }
      } else {
        this.isAddTrainError = true;
      }
    } else if (this.locoPlannedTo === 'terminal') {
      if (this.appUtilityService.isMnemonicExist(this.searchPlanTextTerminal)) {
        if (this.thpPlanLoco && this.thpPlanLoco.trim().toUpperCase() === 'S') {
          if (this.appUtilityService.isValidThpSelection(this.searchPlanTextTerminal)) {
            this.lmsLoaderService.showLoader();
            this.submitTransferToTerminal();
          } else {
            this.lmsLoaderService.hideLoader();
            this.errorDialog = true;
            this.popUpHeaderMessage = this.configData.messages.invalidThpSelection;
          }
        } else {
          this.lmsLoaderService.showLoader();
          this.submitTransferToTerminal();
        }
      } else {
        this.searchPlanTextTerminalError = true;
      }
    }
    this.bottomToTop = '';
  }

  /**
   * this mehtod is helper method
   * in continuation with plan locomotive
   * this method is used to handle transfer to terminal
   * operation
   * @memberOf LmsTrainTopActionsComponent
   */
  submitTransferToTerminal() {
    const locoTransfer: Array<LocoTransfer> = [];
    this.createLocoTransferListForTerminal(locoTransfer, this.searchPlanTextTerminal.toUpperCase(), this.thpPlanLoco);
    this.serviceCallLocoTransfer(locoTransfer, 'XSTA', 'planLocomotive', ' have been planned successfully to Terminal');
  }

  /**
   * this mehtod is helper method
   * in continuation with plan locomotive
   * this method is used to handle transfer to foreignRailRoad
   * operation
   * @memberOf LmsTrainTopActionsComponent
   */
  submitTransferToForeignRailRoad() {
    const locoTransfer: Array<LocoTransfer> = [];
    this.createLocoTransferListForForeignRoad(locoTransfer, this.searchPlanTextTerminal.toUpperCase(), ' ', this.selectedTerminalRoad);
    this.serviceCallLocoTransfer(locoTransfer, 'XROD', 'planLocomotive', ' have been planned successfully to Foreign Road');
  }

  /**
   * This mehtod is used to prepare the
   * transfer to foreignRailRoad request
   * @param {Array<LocoTransfer>} locoTransfer
   * @param {string} terminal
   * @param {string} terminalType
   * @param {string} road
   * @memberOf LmsTrainTopActionsComponent
   */
  createLocoTransferListForForeignRoad(locoTransfer: Array<LocoTransfer>, terminal: string, terminalType: string, road: string) {
    if (this.trainEdit && this.trainEdit.selectedLocomotives) {
      for (let i = 0; i < this.trainEdit.selectedLocomotives.length; i++) {
        const selectedLocmotive = this.trainEdit.selectedLocomotives[i];
        const a = {
          currentTerminalIdentifier: this.trainSVG.currentTerminal, // To be verified
          toRoadIdentifier: road,
          terminalHandlingType: terminalType,
          atStation: terminal,
          locoTransferList: {
            locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier),
            qualifier: selectedLocmotive.qualifier,
            assignedOrPlanned: selectedLocmotive.assignedPlannedFlag
          }
        };
        locoTransfer.push(a);
      }
    }
  }

  /**
   * This mehtod is used to prepare the
   * transfer to terminal request
   * @param {Array<LocoTransfer>} locoTransfer
   * @param {string} terminal
   * @param {string} terminalType
   * @memberOf LmsTrainTopActionsComponent
   */
  createLocoTransferListForTerminal(locoTransfer: Array<LocoTransfer>, terminal: string, terminalType: string) {
    if (this.trainEdit && this.trainEdit.selectedLocomotives) {
      for (let i = 0; i < this.trainEdit.selectedLocomotives.length; i++) {
        const selectedLocmotive = this.trainEdit.selectedLocomotives[i];
        const a = {
          currentTerminalIdentifier: this.trainSVG.currentTerminal, // To be verified
          terminalIdentifier: terminal,
          terminalHandlingType: terminalType,
          locoTransferList: {
            locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier),
            qualifier: selectedLocmotive.qualifier,
            assignedOrPlanned: selectedLocmotive.assignedPlannedFlag
          }
        };
        locoTransfer.push(a);
      }
    }
  }

  /**
   * This is a service call for transfer locomotive
   * @param {Array<LocoTransfer>} locoTransfer
   * @param {string} operation
   * @param {string} popup
   * @param {string} message
   * @memberOf LmsTrainTopActionsComponent
   */
  serviceCallLocoTransfer(locoTransfer: Array<LocoTransfer>, operation: string, popup: string, message: string) {
    this.trainDataService.transferLocomotive(locoTransfer, operation).subscribe(
      (data) => {
        this.transferResponse = <BaseResponse>data;
        if (this.appUtilityService.isNumeric(this.transferResponse.header.priorityCode)) {
          const pCode = parseInt(this.transferResponse.header.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            this.planLocomotive = false;
            this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status = 'refresh';
            this.setDefaultValues();
            this.checkEditModeStatus();
            this.trainDataService.load(this.tab);
            this.messageHandlerService.handleMessage(<MessageDetails>({
              type: this.configData.message.type.client,
              level: this.configData.message.level.success,
              target: this.configData.message.target.page,
              message: this.formatLocomotiveIdToDisplay(locoTransfer[0].locoTransferList.locomotiveIdentifier) + message
            }));
            this.popupService.setPageMode('');
            this.popupService.setSubmitBtnId('');
            this.actionTrigger.emit('resetOps');
          } else {
            this.errorDialog = true;
            this.popUpHeaderMessage = this.transferResponse.header.messageText;
          }
        }
      }, error => {
        this.errorDialog = true;
        this.popUpHeaderMessage = this.appUtilityService.getHttpErroMessage(error, false);
      });
    this.lmsLoaderService.hideLoader();
  }

  /**
   * Format the locomotive id
   * @private
   * @param {string} value
   * @returns {string}
   * @memberOf LmsLocoContextMenuComponent
   */
  private formatLocomotiveIdToDisplay(value: string): string {
    if (value) {
      value = value.trim();
      const v = value.match(/\d+/);
      if (v) {
        const locoInitial = (v.index <= 4) ? value.substring(0, v.index).trim() : value.substring(0, 4).trim();
        const locoNumber = (v.index <= 4) ? value.substring(v.index, value.length).trim() : value.substring(4, value.length).trim();
        return locoInitial + ' ' + locoNumber.replace(/^0+/, '');
      }
    }
  }

  /**
  * Check for train id.
  *
  * @param {string} value
  * @returns {boolean}
  *
  * @memberOf LmsTabsComponent
  */
  isValidTrainId(value: string): boolean {
    let flag = false;
    if (value && value.length === 6) {
      if (!this.appUtilityService.isNumeric(value.charAt(0))) {
        const remainingStr = value.substring(1, value.length);
        if (this.appUtilityService.isNumeric(remainingStr)) {
          flag = true;
        }
      }
    }
    return flag;
  }

  public updateErrorValueForRoad() {
    this.selectedTerminalRoadError = false;
  }

  /**
   * @memberOf LmsTrainTopActionsComponent
   */
  ngOnDestroy() {
    this.trainEdit = null;
    this.popUpServiceSubscription.unsubscribe();
  }

  serviceCallToBre(trainId: string, selectedLocoArr: Array<LocoDetail>, type: string) {
    const locoId: Array<String> = [];
    if (selectedLocoArr) {
      for (let i = 0; i < selectedLocoArr.length; i++) {
        locoId.push(this.appUtilityService.formatLocomotiveId(selectedLocoArr[i].locomotiveIdentifier));
      }
    }
    this.locoTransfer = [];
    this.lmsLoaderService.hideLoader();
    this.trainDataService.breTransferRequest(locoId, trainId).subscribe(
      (data) => {
        const breTrasferParam: BreTransferAreaDetails = <BreTransferAreaDetails>data;
        if (breTrasferParam && breTrasferParam.priorityCode) {
          const pCode = parseInt(breTrasferParam.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            if (this.isLmsExceptionListExist(breTrasferParam)) {
              this.planLocomotive = false;
              this.ruleException = true;
              setTimeout(() => {
                this.popupService.setPageMode('Dialog');
                this.popupService.setSubmitBtnId('ruleExceptionLocoData');
                this.appUtilityService.setFocusToFirstElement('trainDataRuleExcpDialog');
              }, 20);
              const newLmsExceptionList: Array<LmsException> = [];
              for (let i = 0; i < breTrasferParam.lmsExceptionList.length; i++) {
                const lmsException: LmsException = breTrasferParam.lmsExceptionList[i];
                const locoObj: LocoDetail = this.getLocoObjById(lmsException.locoId, selectedLocoArr);
                if (locoObj) {
                  lmsException.intendedUsageDesc = this.appUtilityService.getIntendedUsageDesc(locoObj.intendedUsageCode);
                  lmsException.intendedUsageReason = this.appUtilityService.getIntendedUsageReasonDesc(locoObj.intendedUsageReason);
                  lmsException.intendedUsageNote = locoObj.intendedUsageNote;
                }
                lmsException.isSelectedLoco = false;
                newLmsExceptionList.push(lmsException);
              }
              this.lmsExceptionList = newLmsExceptionList;
              const checkedExceptionList: Array<LmsException> = this.lmsExceptionList.filter((lmsException) => {
                return lmsException.isSelectedLoco;
              });
              if (checkedExceptionList && checkedExceptionList.length > 0) {
                this.isRuleExceptionSubmitEnabled = true;
              }
            } else {
              if (this.trainEdit && this.trainEdit.selectedLocomotives) {
                for (let i = 0; i < this.trainEdit.selectedLocomotives.length; i++) {
                  const selectedLocmotive = this.trainEdit.selectedLocomotives[i];
                  const a = {
                    currentTerminalIdentifier: this.trainSVG.currentTerminal,
                    trainIdentifier: trainId,
                    terminalHandlingType: this.thpPlanLoco,
                    locoTransferList: {
                      locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier),
                      qualifier: selectedLocmotive.qualifier,
                      assignedOrPlanned: selectedLocmotive.assignedPlannedFlag,
                      intendedUsageCode: selectedLocmotive.intendedUsageCode,
                      intendedUsageReason: selectedLocmotive.intendedUsageReason,
                      intendedUsageNotes: selectedLocmotive.intendedUsageNote
                    }
                  };
                  this.locoTransfer.push(a);
                }
              }
              this.serviceCallLocoTransfer(this.locoTransfer, 'XTRN', 'planLocomotive', ' have been planned successfully to Train');
            }
          } else {
            this.errorDialog = true;
            this.popUpHeaderMessage = breTrasferParam.messageText;
          }
        }

      }, error => {
        this.errorDialog = true;
        this.popUpHeaderMessage = this.appUtilityService.getHttpErroMessage(error, false);
      }
    );
  }



  /**
   * Get Loco object by id.
   * @param {string} locoId
   * @param {Array<LocoDetail>} locoArr
   * @returns {LocoDetail}
   * @memberof LmsTrainTopActionsComponents
   */
  getLocoObjById(locoId: string, locoArr: Array<LocoDetail>): LocoDetail {
    for (let x = 0; x < locoArr.length; x++) {
      const oldLocoId = this.appUtilityService.UIformatLocomotiveId(locoId);
      const newLocoId = this.appUtilityService.UIformatLocomotiveId(locoArr[x].locomotiveIdentifier);
      if (oldLocoId && newLocoId && oldLocoId.trim().toUpperCase() === newLocoId.trim().toUpperCase()) {
        return locoArr[x];
      }
    }
  }

  ruleExceptionSubmit() {
    this.locoTransfer = [];
    for (let i = 0; i < this.lmsExceptionList.length; i++) {
      const lmsException: LmsException = this.lmsExceptionList[i];
      if (lmsException.isSelectedLoco) {
        let isException = false;
        if (lmsException.tripPlamCompExcptnInd && lmsException.tripPlamCompExcptnInd === 'E') {
          if (!lmsException.tripPlanOverrideCode) {
            this.lmsExceptionList[i].isLmsExceptionInAddReason = true;
            isException = true;
          } else {
            this.lmsExceptionList[i].isLmsExceptionInAddReason = false;
          }
        }
        if (lmsException.unschdQShopExcptnInd && lmsException.unschdQShopExcptnInd === 'Y') {
          if (!lmsException.unscheduledQShop) {
            this.lmsExceptionList[i].isLmsExceptionInAddQShop = true;
            isException = true;
          } else {
            this.lmsExceptionList[i].isLmsExceptionInAddQShop = false;
          }
        }
        if (!isException) {
          if (this.trainEdit && this.trainEdit.selectedLocomotives) {
            for (let j = 0; j < this.trainEdit.selectedLocomotives.length; j++) {
              const selectedLocmotive = this.trainEdit.selectedLocomotives[j];
              const fomattedLmsExceptionLocoId = this.appUtilityService.formatLocomotiveId(lmsException.locoId).replace('    ', '');
              const formattedSelectedLocoId =
                this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier).replace('    ', '');
              if (fomattedLmsExceptionLocoId === formattedSelectedLocoId) {
                const a = {
                  currentTerminalIdentifier: this.trainSVG.currentTerminal,
                  trainIdentifier: this.planTrainId,
                  terminalHandlingType: this.thpPlanLoco,
                  locoTransferList: {
                    locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(selectedLocmotive.locomotiveIdentifier),
                    qualifier: selectedLocmotive.qualifier,
                    assignedOrPlanned: selectedLocmotive.assignedPlannedFlag,
                    tripPlanCompIndicator: this.lmsExceptionList[i].tripPlamCompExcptnInd,
                    tripPlanTrainIdentifier: this.lmsExceptionList[i].tripPlanTrnId,
                    tripPlanOverrideCode: this.lmsExceptionList[i].tripPlanOverrideCode,
                    tripPlanOverrideReason: this.lmsExceptionList[i].tripPlanOverrideReason,
                    unscheduledQShop: this.lmsExceptionList[i].unscheduledQShop,
                    unscheduledQShopDate: this.lmsExceptionList[i].unscheduledQShopDate,
                    intendedUsageCode: selectedLocmotive.intendedUsageCode,
                    intendedUsageReason: selectedLocmotive.intendedUsageReason,
                    intendedUsageNotes: selectedLocmotive.intendedUsageNote
                  }
                };
                this.locoTransfer.push(a);
              }
            }
          }
        }
      }
    }
    if (this.locoTransfer && this.locoTransfer.length > 0) {
      this.ruleException = false;
      this.planLocomotive = true;
      this.popupService.setPageMode('Dialog');
      this.popupService.setSubmitBtnId('trainPlanLocoSubBtn');
      this.serviceCallLocoTransfer(this.locoTransfer, 'XTRN', 'planLocomotive', ' have been planned successfully to Train');
    }
  }

  public setFocusToGivenElement(inputId: string) {
    if (inputId && inputId.length > 0) {
      setTimeout(() => {
        const input = document.getElementById(inputId);
        if (input) {
          input.focus();
        }
      }, 20);
    }
  }

  checkCheckedLoco(event) {
    const checkedExceptionList: Array<LmsException> = this.lmsExceptionList.filter((lmsException) => {
      return lmsException.isSelectedLoco;
    });
    if (checkedExceptionList && checkedExceptionList.length > 0) {
      this.isRuleExceptionSubmitEnabled = true;
    } else {
      this.isRuleExceptionSubmitEnabled = false;
    }
  }

  cancelOperation(type: string) {
    if ('ruleException' === type) {
      this.isRuleExceptionSubmitEnabled = false;
      this.ruleException = false;
      this.getLocoIncident();
      this.isAddTrainError = false;
      this.errorDialog = false;
      this.popUpHeaderMessage = 'Plan Locomotive';
      this.locoPlannedTo = 'train';
      this.thpPlanLoco = 'S';
      this.changePlanOptions('Plan Locomotive');
      this.popupService.setPageMode('Dialog');
      this.popupService.setSubmitBtnId('trainPlanLocoSubBtn');
    }
  }

  isLmsExceptionListExist(breTrasferParam: BreTransferAreaDetails): boolean {
    if (breTrasferParam && breTrasferParam.lmsExceptionList && breTrasferParam.lmsExceptionList.length > 0) {
      for (let i = 0; i < breTrasferParam.lmsExceptionList.length; i++) {
        const lmsExcpetion = breTrasferParam.lmsExceptionList[i];
        if (lmsExcpetion && 'E' === lmsExcpetion.tripPlamCompExcptnInd) {
          return true;
        }
        if (lmsExcpetion && 'Y' === lmsExcpetion.unschdQShopExcptnInd) {
          return true;
        }
        if (lmsExcpetion && lmsExcpetion.exceptionMessage && lmsExcpetion.exceptionMessage.length > 0) {
          return true;
        }
      }
    }
    return false;
  }

  checkForContextMenuVisiblity(event) {
    this.hideContextMenu.emit(true);
  }

  public setFocusToFirstElement(btnId: string, dialogId: string) {
    const element = document.getElementById(btnId);
    if (element) {
      if (btnId === 'planLocoOptions') {
        element.removeAttribute('id');
        const actual = element.children[0].children[1].children;
        actual[0].setAttribute('id', btnId);
        document.getElementById(btnId).focus();
      } else {
        element.focus();
      }
    }
    setTimeout(() => {
      this.appUtilityService.setFocusToFirstElement(dialogId);
    }, 20);
  }

  getLocoIncident() {
    if (this.trainEdit && this.trainEdit.selectedLocomotives) {
      for (let i = 0; i < this.trainEdit.selectedLocomotives.length; i++) {
        const locoData: LocoDetail = this.trainEdit.selectedLocomotives[i];

        if (locoData && locoData.deadFlag && locoData.deadFlag.trim().toUpperCase() === 'Y') {
          this.trainEdit.selectedLocomotives[i].locoIncident = 'OOS';

        } else if (locoData.trfIncidentS && locoData.trfIncidentS.trim().toUpperCase() === 'Y') {
          this.trainEdit.selectedLocomotives[i].locoIncident = 'TRF';

        } else if (locoData.axles && locoData.axles.trim() === '4') {
          this.trainEdit.selectedLocomotives[i].locoIncident = '4-ax';

        } else if (!locoData.axles || (locoData.axles && (locoData.axles.trim().length === 0 || locoData.axles.trim() === '6'))) {
          this.trainEdit.selectedLocomotives[i].locoIncident = '6-ax';

        }
      }
    }
    this.intendedTrainEdit = JSON.parse(JSON.stringify(this.trainEdit));
    this.planLocomotive = true;
  }

  /**
   * Get formatted locomotive id for display.
   * @param {string} locoId
   * @returns
   * @memberof LmsTrainTopActionsComponent
   */
  getLocomotiveId(locoId: string) {
    if (locoId) {
      return this.appUtilityService.UIformatLocomotiveId(locoId);
    }
    return '';
  }
}
